import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {fullNameById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import FullName from './FullName';

export default connect(
  createStructuredSelector({
    name: withProps({coachId: userId})(fullNameById),
  }),
)(FullName);
